import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { TagsInfoType } from "../../helpers/resourceHelper";
import { useOperation } from "../../hooks/useOperation";
import { OperationProps } from "../OperationTypes";
import { ExaDbUpdateTagsPdbProps, newExaDbUpdateTagsPdb } from "./ExaDbUpdateTagsPdb";

export interface ExaDbEditTagsPdbProps extends OperationProps {
  databaseId: string;
  defaultTags?: TagsInfoType;
}

const ExaDbEditTagsPdb = (
  { location, databaseId, defaultTags, onExecute, onCancel }: ExaDbEditTagsPdbProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsPdb } = useOperation<ExaDbUpdateTagsPdbProps>(newExaDbUpdateTagsPdb);

  return (
    <TagsEditPanel
      title={Messages.labels.editTags()}
      resourceId={databaseId}
      tagsDefaultValue={defaultTags}
      onSubmit={(formValues: FormValues) => {
        const tags = getValue<TagsInfoType>(formValues, TagDetailsFields.Tags, InputFormGroup) ?? [];
        triggerUpdateTagsPdb({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newExaDbEditTagsPdb = (
  props: ExaDbEditTagsPdbProps,
): JSX.Element => (<ExaDbEditTagsPdb {...props} />);
